import { PropsWithChildren } from 'react';
import { FeeLoaderProps } from './props';
import styles from '../styles.module.scss';

export default function FeeLoader({
  isLoading,
  children,
}: PropsWithChildren<FeeLoaderProps>) {
  if (isLoading) {
    return (
      <i
        className={`${styles.container__spinner} fas fa-circle-notch fa-spin`}
      />
    );
  }

  return children;
}
